import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    cardWithTransition: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      margin: theme.spacing(0, 2, 2, 2),
      minHeight: 200
    },
    cardContent: {
      flexGrow: 1,
      paddingTop: '0px !important',
      justifyContent: 'space-between',
      display: 'flex',
      flexDirection: 'column'
    },
    cardEmptyContent: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      flexGrow: 1,
      marginBottom: theme.spacing(2)
    },
    cardActionsRight: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    tooltip: {
      display: 'flex',
      alignItems: 'flex-center',
      marginTop: '0px !important',
      marginLeft: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    tooltipIcon: {
      padding: '0px',
      marginRight: theme.spacing(1)
    },
    tooltipCaption: {
      fontStyle: 'italic'
    },
    loadingCard: {
      margin: theme.spacing(0, 2, 2, 2)
    }
  })
